const VARIANTS = {
  BULLISH: { label: '▲ BULLISH', cls: 'bg-green-500/15 text-green-600' },
  BEARISH: { label: '▼ BEARISH', cls: 'bg-red-500/15 text-red-600' },
  NEUTRAL: { label: '— NEUTRAL', cls: 'bg-slate-500/15 text-slate-600' },
  MIXED:   { label: '↕ MIXED',   cls: 'bg-yellow-500/15 text-yellow-600' },
};

const SIZE = {
  sm: 'text-[10px] px-1.5 py-0.5',
  md: 'text-[11px] px-2 py-0.5',
  lg: 'text-xs px-2.5 py-1',
};

export default function DirectionBadge({ direction, size = 'md' }) {
  const { label, cls } = VARIANTS[direction] || VARIANTS.NEUTRAL;
  return (
    <span className={`inline-flex items-center rounded font-bold tracking-wide whitespace-nowrap ${cls} ${SIZE[size]}`}>
      {label}
    </span>
  );
}
